import React from "react";
import Typography from "@material-ui/core/Typography";
const Warehouse = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Warehouse
      </Typography>
      <Typography paragraph variant="h5">
        Manage warehouse master data to simplify daily operational
      </Typography>
      <Typography paragraph variant="body1">
        Warehouse is one of the features under the Inventory module to manage
        warehouse master data which is ready to operate daily operational. It
        contains any information regarding the warehouse location and address
        details of each warehouse.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Warehouse list.
        It is displayed like a table that contains download functions, sort,
        filter, and global search on the header area, and contains data
        navigation and refresh function on the footer area. The data column that
        appears in this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Warehouse ID</b>
        <br />
        Indicates the ID of the Warehouse.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Warehouse Name</b>
        <br />
        Indicates the full name of the Warehouse.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Phone Number</b>
        <br />
        Indicates the contact phone number of the Warehouse.
      </Typography>
      <Typography paragraph variant="body1">
        <b>City</b>
        <br />
        Indicates the city location of the Warehouse.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 3 buttons that appear on each row of Warehouse data
        with specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Whatsapp Chat Warehouse</b>
        <br />
        This button only appears if the Warehouse has a valid phone number. It
        is used to automatically redirect to WhatsApp API to send a conversation
        to the Warehouse.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Warehouse</b>
        <br />
        This button is used to edit the Warehouse data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Warehouse</b>
        <br />
        This button is used to delete the Warehouse data. The Warehouse data is
        undeletable once it have transactions.
      </Typography>
    </React.Fragment>
  );
};

export default Warehouse;
